<template>
  <v-container
    fluid
    grid-list-xl
  >
    <app-monitoramento
      :acesso="acesso"
      monitoramento="mapeamento"
      titulo="Competências Comportamentais"
    >
      <template v-slot:body>
        <v-col v-if="mapeamento.mapeamentoImportado && loaded">
          <app-alert
            type="info"
            :message="`Mapeamento importado através do mapeamento (${mapeamento.mapeamentoImportado.nome})`"
          />
        </v-col>
        <v-col
          v-else
          centered
          cols="12"
          no-gutters
        >
          <v-row
            v-if="loaded"
            class="justify-center ma-2"
          >
            <v-tabs
              v-model="categoria"
              centered
              icons-and-text
            >
              <v-tabs-slider color="secondary" />
              <v-tab
                v-for="i in categorias.length"
                :key="i"
                :href="'#' + categorias[i - 1].id"
                class="mt-3"
              >
                <span class="grey--text text--darken-2">{{
                  categorias[i - 1].descricao
                }}</span>
                <v-icon
                  :color="
                    categorias[i - 1].id === categoria ? 'secondary' : 'grey'
                  "
                >
                  {{ categorias[i - 1].icone }}
                </v-icon>
              </v-tab>
            </v-tabs>
          </v-row>
          <v-row class="justify-center ma-2">
            <keep-alive>
              <component
                :is="categoria"
                v-if="loaded"
                :mapeamento="mapeamento"
              />
            </keep-alive>
          </v-row>
        </v-col>
      </template>
    </app-monitoramento>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import AppMonitoramento from '@/components/core/AppMonitoramento';
import AppAlert from '@/components/core/AppAlert';
import MonitoramentoGeral
from '@/views/monitoramento/mapeamento/comportamento/tabs/MonitoramentoMapeamentoGeralComportamental';
import MonitoramentoGeralComportamento
from '@/components/monitoramento/mapeamento/MonitoramentoGeralComportamento';
import MonitoramentoGeralCompetenciaComportamental
from '@/components/monitoramento/mapeamento/MonitoramentoGeralCompetenciaComportamental';
import MonitoramentoUnidade
from '@/views/monitoramento/mapeamento/comportamento/tabs/MonitoramentoMapeamentoUnidadeComportamental';

export default {
  name: 'MonitoramentoMapeamentoComportamental',

  components: {
    AppMonitoramento,
    AppAlert,
    MonitoramentoGeral,
    MonitoramentoGeralComportamento,
    MonitoramentoGeralCompetenciaComportamental,
    MonitoramentoUnidade,
  },

  data() {
    return {
      acesso: null,
      categoria: 'MonitoramentoGeral',
    };
  },

  computed: {
    ...mapState({
      isTutorialExibido: (state) => state.tutorial.dados.monitoramentoMapeamentoComportamental,
      unidade: (state) => state.auth.unidade,
      comissao: (state) => state.auth.comissao,
      usuarioMapeamento: (state) => state.mapeamento.usuarioMapeamento,
      chefia: (state) => state.auth.chefia,
      substituicaoChefia: (state) => state.auth.substituicaoChefia,
      mapeamento: (state) => {
        if (state.auth.comissao) {
          return state.mapeamento.mapeamentoComissao;
        }
        return state.mapeamento.mapeamento;
      },
    }),
    loaded: {
      get() {
        return this.$store.state.monitoramento.mapeamento.loaded;
      },
      set(status) {
        const payload = { modulo: 'MAPEAMENTO', status };
        this.$store.dispatch('monitoramento/setLoadedStatus', payload);
      },
    },
    categorias() {
      const categorias = [
        {
          id: 'MonitoramentoUnidade',
          descricao: 'Monitoramento por Unidade',
          icone: 'account_balance',
          component: 'MonitoramentoUnidade',
        },
      ];

      if (this.$store.state.monitoramento.mapeamento.unidades.length > 1) {
        categorias.splice(0, 0, {
          id: 'MonitoramentoGeral',
          descricao: 'Monitoramento Geral',
          icone: 'leaderboard',
          component: 'MonitoramentoGeral',
        });
      }
      return categorias;
    },
  },

  watch: {
    mapeamento() {
      this.loaded = false;
      this.initialize();
    },
  },

  created() {
    if (this.comissao) {
      this.acesso = 'COMISSAO';
    } else if (this.chefia || this.substituicaoChefia) {
      this.acesso = 'COMUM';
    }
    this.initialize();
  },

  methods: {
    initialize() {
      if (!this.loaded) {
        let payload;
        if (this.acesso === 'COMISSAO') {
          payload = {
            mapeamento: this.mapeamento.id,
            unidade: null,
          };
        } else if (this.acesso === 'COMUM') {
          payload = {
            mapeamento: this.mapeamento.id,
            unidade: this.usuarioMapeamento.unidade.idVersao,
          };
        }
        this.$store.dispatch('monitoramento/loadMonitoramentoMapeamento', payload).then(async () => {
          this.loaded = true;
          if (this.$store.state.monitoramento.mapeamento.unidades.length > 1) {
            this.categoria = 'MonitoramentoGeral';
          } else {
            this.categoria = 'MonitoramentoUnidade';
          }
        });
      } else {
        this.categoria = 'MonitoramentoGeral';
      }

      if (!this.isTutorialExibido && this.acesso) {
        let tutorial = '';
        if (this.$store.state.monitoramento.mapeamento.unidades.length > 1) {
          tutorial = 'MonitoramentoMapeamentoGeralComportamental';
        } else {
          tutorial = 'MonitoramentoMapeamentoUnidadeComportamental';
        }
        this.$store.dispatch('app/showTutorial', {
          nome: tutorial,
          nomeGenerico: 'MonitoramentoMapeamentoComportamental',
        });
      }
    },
  },
};
</script>
